<script lang="ts">
    import type { Snippet } from "svelte";

    interface Props {
        extraClasses?: string;
        fullContent?: boolean;
        reduceOnSmallScreen?: boolean;
        showButtons?: boolean;
        children?: Snippet;
        buttons?: Snippet;
        onclick?: () => void;
    }

    let {
        extraClasses = "",
        fullContent = false,
        reduceOnSmallScreen = false,
        showButtons = true,
        children,
        buttons,
        onclick,
    }: Props = $props();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
    class="popup-container animation responsive z-20 flex min-h-20 min-w-60 flex-col overflow-hidden rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)] transition-all {extraClasses}"
    class:responsive={reduceOnSmallScreen}
    {onclick}
>
    <div class="flex items-center p-4 px-10 pointer-events-auto justify-center grow">
        <div class="text-center leading-6 responsive-message {fullContent ? 'w-full' : ''}">
            {@render children?.()}
        </div>
    </div>
    {#if showButtons && buttons}
        <div
            class="buttons-wrapper pointer-events-auto flex items-center justify-center space-x-2 border-t border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-2"
        >
            {@render buttons()}
        </div>
    {/if}
</div>

<style>
    .animation {
        animation-duration: 0.5s;
        animation-name: slidein;
    }

    @keyframes slidein {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
</style>
